import __TOPRIGHT from './TopRight';
import __USER from './User';

const Components = {
    TopRight : __TOPRIGHT,
    User : __USER
}

export default Components;